<template lang="html">
  <pl-dialog
    :disableOutsideClick="true"
    @close="$emit('close')"
    padding="2em 3em"
    maxWidth="800px"
  >
    <pl-button
      class="pl-icon"
      style="position: absolute; top: 0; right: 0"
      @click.native="$emit('close')"
    >
      <i class="fa fa-close"></i>
    </pl-button>

    <div class="mt3 flex items-center" style="flex-direction: column">
      <div class="b f3">
        <strong>You have to connect a class.</strong>
      </div>
      <div class="i f7 mt2 pl-primary">
        How does this work?
        <i
          class="fas fa-external-link-alt"
          style="font-size: 8px; vertical-align: top"
        ></i>
      </div>
    </div>
    <div class="center mv4">
      <p class="tc pl2 txt-modal-upgrade">
        You must connect this Parlay Course to a corresponding Course in
        {{ selected_integration }} before you can create an assignment in
        {{ selected_integration }}.
      </p>
    </div>
    <div class="integrations-container w-70">
      <div class="row col-xs no-margin middle-xs between-xs">
        <div>
          <img :src="logo" style="height: 3.5em; width: 3.5em" />
          <span class="integration-classroom-title ml3">
            {{ selected_integration }}
          </span>
        </div>
        <pl-button
          class="db b truncate-text"
          style="
            margin: 0;
            border-right: 1px solid rgba(0, 0, 0, 0.2);
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            min-width: 150px;
          "
          @click.native="connectOrUpdateIntegration"
        >
          Connect Class
        </pl-button>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {};
    },
    props: {
      logo: {
        type: String,
        required: true,
      },
      edLink: {
        type: Boolean,
        required: true,
      },
      selectedIntegration: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail']),
      selected_integration() {
        if (this.selectedIntegration === 'google-classroom') {
          return 'Google Classroom';
        }
        return (
          this.selectedIntegration.charAt(0).toUpperCase() +
          this.selectedIntegration.slice(1)
        );
      },
      integration() {
        return this.getCourseDetail.edlink_integrations.find(
          (x) => x.provider_name.toLowerCase() === this.selectedIntegration
        );
      },
    },
    methods: {
      connectOrUpdateIntegration() {
        const course_id = this.$route.params.courseID;
        const route = {
          name: 'course.settings.integrations',
          params: {
            courseID: course_id,
          },
          query: {},
        };
        this.$router.push(route);
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .integrations-container
    margin-left: auto
    margin-right: auto
    margin-bottom: 20px
    padding: 1rem
    border-right: 1px solid rgba(0,0,0,.2)
    border-bottom: 1px solid rgba(0,0,0,.2)
  .integration-classroom-title
    font-size: 18px
    line-height: 22px
    color: #273248
    font-weight: 600
  .google_classroom_connected
    margin: 16px 0 0 0
  .name-of-class
    display: block
    font-size: 24px
    line-height: 29px
    color: #273248
    font-weight: 600
</style>



// WEBPACK FOOTER //
// integrationsConnectModal.vue?2276f743